import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/alteracao-resultado-lancamento`

    return {
        list(queryParms) {

            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        datatable(queryParms) {

            return repository.get(`${baseUrl}/datatable?${urlUtil.serialize(queryParms)}`)
        },
        download(id) {
            return repository.get(`${baseUrl}/${id}/download`, { responseType: "arraybuffer" })
        },
        store(params) {

            return repository.post(`${baseUrl}`, params, {

                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
        },
        edit(id) {

            return repository.get(`${baseUrl}/${id}/edit`)
        },
    }
}